/* eslint-disable sonarjs/no-duplicate-string */

// FIXME: в форме сейчас тоже дубликат пока, надо подумать куда это вынести и как забирать
// Возможно утащить в dc-form-api/utils/analytics
const getFieldAnalytics = (block: string) => ({
    focus: {
        block,
        event: 'gtm_interaction_event',
        action: 'Enter',
        label_detail: 'Ввод данных',
    },
    correct: {
        block,
        event: 'gtm_interaction_event',
        action: 'Enter',
        label_detail: 'Успешный ввод',
    },
    incorrect: {
        block,
        event: 'gtm_interaction_event',
        action: 'Enter',
        label_detail: 'Ошибка',
    },
});

export const deliveryStepAnalytics = {
    view: {
        block: 'Заказ доставки',
        event: 'gtm_non_interaction_event',
        action: 'View',
        ymEvent: [
            {
                method: 'reachGoal',
                params: 'dc_address_step',
            },
        ],
        label_detail: 'Доставка',
    },
    // TODO: ошибка в слове delEvery, по коду совпадений не нашел, возможно что-то уже старое
    deleveryUnavailable: {
        block: 'Заказ доставки',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Нет доступных способов доставки',
    },
    cashbackError: {
        block: 'Категории кэшбэка 2-ой шаг',
        event: 'gtm_non_interaction_event',
        action: 'View',
        label_detail: 'Недоступен выбранный кэшбек',
    },
    brokerage: {
        click: (checked: boolean) => ({
            block: 'Заказ доставки - Брокерский счет',
            event: 'gtm_interaction_event',
            action: 'Click',
            label_detail: checked ? 'Включено' : 'Выключено',
        }),
        view: (checked: boolean) => ({
            block: 'Заказ доставки - Брокерский счет',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: checked ? 'Включено' : 'Выключено',
        }),
    },
    submit: {
        fail: {
            block: 'Анкета - Шаг 2',
            event: 'gtm_interaction_event',
            action: 'Send',
            label_detail: 'Ошибка отправки формы',
        },
        success: {
            block: 'Анкета - Шаг 2',
            event: 'gtm_interaction_event',
            action: 'Send',
            label_detail: 'Успешная отправка формы',
        },
    },
    formFields: {
        codeWord: getFieldAnalytics('Кодовое слово'),
        comment: getFieldAnalytics('Комментарий в доставке по адресу'),
        deliveryAddress: getFieldAnalytics('Адрес доставки'),
    },
    timeSlots: {
        view: {
            block: 'Дата и время',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Дата и время',
        },
        error: {
            block: 'Дата и время',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Выбранный слот недоступен',
        },
        date: {
            click: {
                block: 'Дата и время',
                event: 'gtm_interaction_event',
                action: 'Click',
                label_detail: 'Выбор даты',
            },
        },
        time: {
            click: {
                block: 'Дата и время',
                event: 'gtm_interaction_event',
                action: 'Click',
                label_detail: 'Выбор время',
            },
        },
    },
    deliveryType: {
        click: (item: string) => ({
            block: 'Куда доставить',
            event: 'gtm_interaction_event',
            action: 'Choice',
            label_detail: item,
        }),
        view: (item: string) => ({
            block: 'Куда доставить',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: item,
        }),
    },
    deliveryMethod: {
        incorrect: {
            block: 'Заказ доставки',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Нет доступных способов доставки',
        },
    },
    officeDelivery: {
        anyOffice: {
            block: 'Заказ доставки',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Любой офис банка',
        },
        view: {
            block: 'Выберите офис банка',
            event: 'gtm_non_interaction_event',
            action: 'View',
            label_detail: 'Выберите офис банка',
        },
        focus: {
            block: 'Выберите офис банка',
            event: 'gtm_interaction_event',
            action: 'Choice',
            label_detail: 'Ввод данных',
        },
        choice: {
            block: 'Выберите офис банка',
            event: 'gtm_interaction_event',
            action: 'Choice',
            label_detail: 'Успешный выбор',
        },
    },
};
